import { createRoot } from 'react-dom/client';
import React from 'react';
import ZooPassApp from "./ZooPass/ZooPassApp";
import {ZooPassContextProvider} from "./ZooPass/Context/ZooPassAppContext";
import {ZooPassAppAnswersContextProvider} from "./ZooPass/Context/ZooPassAnswersContext";
import {AnimalSponsorshipContextProvider} from "./Animal/Context/AnimalSponsorshipAppContext";
import {AnimalSponsorshipApp} from "./Animal/AnimalSponsorshipApp";
import { AccountProvider } from './MyAccount/Contexts/AccountContext';
import AccountLayout from './MyAccount/AccountLayout';

// declare my helper in the window interface
declare global {
    interface Window {
        ReactComponent: ReactComponent,
        baseApiUrl: string,
        apiCulture: string,
        apiKey: string,
        tnewUrl: string,
        zooPassUrl: string,
    }
}


export class ReactComponent {
    static InitZooPass(containerID: string): void {

        let container = document.getElementById(containerID);
        if (container) {
            const root = createRoot(container);
            if(containerID == "zoopass")
            {
                root.render(<ZooPassContextProvider>
                    <ZooPassAppAnswersContextProvider>
                        <ZooPassApp/>
                    </ZooPassAppAnswersContextProvider>
                </ZooPassContextProvider>);
            }
            
            if(containerID == "animalsponsorship")
            {
                root.render(<AnimalSponsorshipContextProvider>
                        <AnimalSponsorshipApp/>
                </AnimalSponsorshipContextProvider>);
            }

            if (containerID == "myaccount") {
                root.render(<AccountProvider>
                    <AccountLayout />
                </AccountProvider>);
            }
            
        }
    }
}
window.ReactComponent = ReactComponent;
